module.exports = __webpack_public_path__ + "img/figure4.af531a58.png";